import { useSelector } from 'hooks/utils';
import { selectEntriesRowsById } from 'store/data/entries';

export function useEntriesById(entryIds: string[]) {
	return useSelector(state => selectEntriesRowsById(state.data.entries, entryIds));
}
